import { SpacingWrapper } from '@finn/platform-modules';
import { ModalContainer, ModalKey } from '@finn/ua-modals';
import { cn, isMobileApp } from '@finn/ui-utils';
import { ReactNode } from 'react';

import { PartialCartInfo } from '../../product-pricing';
import { CarInformationDrawer } from './CarInformationDrawer';
import { ProductDetails } from './ProductDetails';

type Props<T> = {
  pageData: T;
  cosmicModules: ReactNode;
  renderPromoSection: () => ReactNode;
  closedUserGroupId?: string;
  cartInfo?: PartialCartInfo;
  onAddToCart: () => void;
  triggerDevModal?: () => void;
  priceAreaChildren?: ReactNode;
  partnerVoucherBanner?: ReactNode;
  onCheckout?: ({
    id,
    term,
    kilometerPackage,
    downPaymentAmount,
  }: {
    id: any;
    term: any;
    kilometerPackage: any;
    downPaymentAmount: any;
  }) => void;
};

export const ProductDetailsContainer = <T,>({
  cosmicModules,
  pageData,
  renderPromoSection,
  closedUserGroupId,
  cartInfo,
  onAddToCart,
  triggerDevModal,
  priceAreaChildren,
  onCheckout,
  partnerVoucherBanner,
}: Props<T>) => {
  const isApp = isMobileApp();

  const productPageData = pageData;
  const productDetailsData =
    (productPageData as any)?.metadata?.content?.product_details ?? {};

  return (
    <div
      className={cn('md:mt-6', isApp && 'mt-6')}
      data-appid="product-details"
    >
      <ProductDetails
        onAddToCart={onAddToCart}
        pageData={productPageData}
        renderPromoSection={renderPromoSection}
        closedUserGroupId={closedUserGroupId}
        cartInfo={cartInfo}
        triggerDevModal={triggerDevModal}
        priceAreaChildren={priceAreaChildren}
        onCheckout={onCheckout}
        partnerVoucherBanner={partnerVoucherBanner}
      />
      {cosmicModules}
      <SpacingWrapper />
      <ModalContainer
        modalKey={ModalKey.PDP_CAR_INFO}
        ModalComponent={CarInformationDrawer}
        productDetailsData={productDetailsData}
      />
    </div>
  );
};
